import styled from "@emotion/styled"
import { SkeletonComponent } from "./SkeletonComponent"

export const SkeletonPicture = styled(SkeletonComponent)<{
	$aspectRatio?: "4/3" | "16/9"
	$width?: string
}>`
	${({ $aspectRatio }) => `aspect-ratio: ${$aspectRatio ?? "4/3"};`};
	${({ $width }) => $width && `min-width: ${$width};`};
`
